(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles-slider"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function(){
    $('.custom-carousel').owlCarousel({
      loop: false,
      margin: 15,
      nav: true,
      dots: false,
      navText: [
        '<span class="owl-prev-icon">‹</span>',
        '<span class="owl-next-icon">›</span>'
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        992: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-autism"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Accordion toggle
  const headers = document.querySelectorAll('.image-accordion__accordion-header');

  headers.forEach((header) => {
    header.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const content = this.nextElementSibling;

      if (!content) return;

      if (content.hidden || !content.style.maxHeight) {
        // Close other accordions first
        headers.forEach(h => {
          if (h !== header) {
            h.setAttribute('aria-expanded', false);
            const c = h.nextElementSibling;
            if (c) {
              c.style.maxHeight = null;
              c.hidden = true;
              const icon = h.querySelector('.image-accordion__accordion-icon');
              if (icon && icon.dataset.iconInactive) {
                icon.src = icon.dataset.iconInactive;
              }
            }
          }
        });

        // Open this one
        content.hidden = false;
        content.style.maxHeight = content.scrollHeight + 'px';

        const icon = this.querySelector('.image-accordion__accordion-icon');
        if (icon && icon.dataset.iconActive) {
          icon.src = icon.dataset.iconActive;
        }
      } else {
        // Close this one
        content.style.maxHeight = null;
        content.hidden = true;

        const icon = this.querySelector('.image-accordion__accordion-icon');
        if (icon && icon.dataset.iconInactive) {
          icon.src = icon.dataset.iconInactive;
        }
      }
    });
  });

  // Video embed lazy load logic
  const section = document.getElementById('image-accordion-{{ section.id }}');
  if (!section) return;

  const videoWrapper = section.querySelector('.video-wrapper');
  if (!videoWrapper) return;

  const videoEmbedDiv = videoWrapper.querySelector('.video-embed');
  if (!videoEmbedDiv) return;

  const videoId = videoWrapper.dataset.videoId;
  const videoType = videoWrapper.dataset.videoType;
  const customThumbnailUrl = videoWrapper.dataset.customThumbnailUrl;
  const defaultThumbnailUrl = videoWrapper.dataset.defaultThumbnailUrl;
  const videoTitle = videoWrapper.dataset.videoTitle || 'Video';

  if (!videoId || videoId === "null" || videoId === "" || !videoType || videoType === "null") {
    videoEmbedDiv.innerHTML = '<p class="video-no-config">No video configured.</p>';
    return;
  }

  const hasCustomThumbnail = customThumbnailUrl && customThumbnailUrl !== "null" && customThumbnailUrl !== "";
  const hasDefaultThumbnail = defaultThumbnailUrl && defaultThumbnailUrl !== "null" && defaultThumbnailUrl !== "";
  let thumbnailUrl = hasCustomThumbnail ? customThumbnailUrl : (hasDefaultThumbnail ? defaultThumbnailUrl : null);

  function loadAndPlayVideo() {
    if (videoEmbedDiv.querySelector('iframe')) return;

    let iframeSrc = '';
    const youtubeParams = 'autoplay=1&modestbranding=1&rel=0&iv_load_policy=3&showinfo=0&controls=1&enablejsapi=1&origin=' + window.location.origin;
    const vimeoParams = 'autoplay=1&title=0&byline=0&portrait=0&api=1&pip=0';

    if (videoType === 'youtube') {
      iframeSrc = `https://www.youtube.com/embed/${videoId}?${youtubeParams}`;
    } else if (videoType === 'vimeo') {
      iframeSrc = `https://player.vimeo.com/video/${videoId}?${vimeoParams}`;
    }

    if (iframeSrc) {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', iframeSrc);
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('title', videoTitle);

      videoEmbedDiv.innerHTML = '';
      videoEmbedDiv.appendChild(iframe);
    } else {
      videoEmbedDiv.innerHTML = '<p class="video-no-config">Could not load video.</p>';
    }
  }

  if (thumbnailUrl) {
    videoEmbedDiv.innerHTML = `
      <div class="video-thumbnail-wrapper">
        <img src="${thumbnailUrl}" alt="Thumbnail for ${videoTitle}" class="video-thumbnail-image" loading="lazy">
        <button type="button" class="video-play-icon-button" aria-label="Play video: ${videoTitle}">
          <svg class="play-icon" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="48" fill="#F1592E"/>
            <path d="M67.5 50L41.25 65.1554L41.25 34.8446L67.5 50Z" fill="white"/>
          </svg>
        </button>
      </div>
    `;
    const playButton = videoEmbedDiv.querySelector('.video-play-icon-button');
    if (playButton) {
      playButton.addEventListener('click', loadAndPlayVideo, { once: true });
    }
  } else {
    loadAndPlayVideo();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-icon-list"] && !Shopify.designMode) return;
  try {
    
  // No JavaScript needed for the icon list functionality.
  // The accordion JavaScript has been removed.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offerings-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.offerings-box-btns .btn-2').click(function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        var target = $($(this).attr('href')); // Get the target element
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 130 // Adjust scroll position by 130px
            }, 600); // Animation speed in milliseconds
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.acc-item');

  accordions.forEach(item => {
    const header = item.querySelector('.acc-header');
    const content = item.querySelector('.acc-content');
    const icon = item.querySelector('.acc-icon');

    // Handle initial state for "Open by default"
    if(item.classList.contains('is-active')) {
       content.style.maxHeight = content.scrollHeight + "px";
    }

    header.addEventListener('click', () => {
      const isActive = item.classList.contains('is-active');
      
      // Toggle current
      if (isActive) {
        item.classList.remove('is-active');
        content.style.maxHeight = null;
        if(icon.dataset.inactive) icon.src = icon.dataset.inactive;
      } else {
        item.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + "px";
        if(icon.dataset.active) icon.src = icon.dataset.active;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
